import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import Monogram from "@/components/Monogram";
import { SERVICES } from "@/content/site";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <>
      <section className="pt-44 pb-20 px-6 lg:px-14 bg-[#F5F2ED] relative overflow-hidden">
        <Monogram size={620} opacity={0.05} color="#4A3E39" className="absolute -top-20 -right-40 hidden md:block" />
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="eyebrow mb-6">The Atelier</div>
            <h1 className="font-display font-light text-ivory-800 text-6xl md:text-8xl lg:text-[120px] leading-[0.95] max-w-5xl">
              Services, <em className="italic">slowly</em>.
            </h1>
            <p className="mt-10 max-w-xl text-[15px] leading-[1.9] text-ivory-700">
              Each room is a discipline of its own — hair, nails, makeup, bridal, essentials.
              Pricing is indicative; every treatment begins with a short consultation.
            </p>
          </Reveal>
        </div>
      </section>

      {SERVICES.map((s, idx) => {
        const reverse = idx % 2 === 1;
        const bg = idx % 2 === 0 ? "#F5F2ED" : "#EEE7DE";
        return (
          <section
            key={s.slug}
            data-testid={`service-section-${s.slug}`}
            className="py-24 lg:py-36 px-6 lg:px-14"
            style={{ backgroundColor: bg }}
          >
            <div className={`max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <Reveal className="lg:col-span-7">
                <div className="zoom-wrap aspect-[4/5] w-full overflow-hidden">
                  <img src={s.image} alt={s.title} className="zoom-img w-full h-full object-cover" />
                </div>
              </Reveal>
              <Reveal className="lg:col-span-5" delay={120}>
                <div className="eyebrow mb-4">{s.line} — {s.title}</div>
                <h2 className="font-display font-light text-ivory-800 text-5xl md:text-7xl leading-none">
                  {s.title}
                </h2>
                <p className="mt-8 text-[15px] leading-[1.9] text-ivory-700 max-w-md">
                  {s.description}
                </p>
                <ul className="mt-12 space-y-4 max-w-md">
                  {s.items.map((it) => (
                    <li key={it.name} className="flex items-end justify-between border-b border-[#B7AB9B]/60 pb-3">
                      <span className="text-[15px] text-ivory-800">{it.name}</span>
                      <span className="font-mono text-[13px] text-ivory-700">{it.price}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/book" data-testid={`service-book-${s.slug}`} className="btn-burgundy mt-12">
                  Book {s.title} <ArrowUpRight size={14} />
                </Link>
              </Reveal>
            </div>
          </section>
        );
      })}
    </>
  );
}
